@let activeFilters = activeFiltersChips();
@let roomsData = rooms();
<!--@let number = managedSpacesLength();-->

<ng-template #skeletonCard>
  <div class="room-card-skeleton" aria-hidden="true">
    <div class="skeleton-image"></div>
    <div class="skeleton-info">
      <div class="skeleton-title-row">
        <div class="skeleton-title-group">
          <div class="skeleton-line skeleton-line--title"></div>
          <div class="skeleton-line skeleton-line--subtitle"></div>
        </div>
        <div class="skeleton-favorite"></div>
      </div>
      <div class="skeleton-meta-row">
        <div class="skeleton-pill skeleton-pill--wide"></div>
        <div class="skeleton-pill"></div>
      </div>
    </div>
  </div>
</ng-template>

@if (activeFilters.length > 0 && !isFavoriteRoute) {
  <div class="room-filters">
    @for (chip of activeFilters; track $index) {
      <rds-chip
        size="m"
        closable
        (closeChip)="closeChip(chip.formControl, chip.formGroup)">
        {{ chip.label }}: {{ chip.value }}
      </rds-chip>
    }
    <button rds-text-button (click)="resetFilers()">Reset all filters</button>
  </div>
}

<rds-tabs
  stretch
  ariaLabel="Rooms and multi-space tabs"
  (selectedTabChange)="onTabChange($event)">
  <rds-tab [active]="!isCalendarActivated()">
    <ng-template rds-tab-label>
      <span>Rooms</span>
      <rds-badge
        [label]="totalRoomsCount() + ''"
        size="s"
        color="neutral"></rds-badge>
    </ng-template>
    <div class="room-info-cards">
      @if (isInitialLoading()) {
        @for (placeholder of skeletonPlaceholders(); track placeholder) {
          <ng-container [ngTemplateOutlet]="skeletonCard"></ng-container>
        }
      } @else {
        @for (room of roomsData; track room.dexId) {
          <bus-room-card
            [roomData]="room"
            (unfavorited)="onRoomUnfavorited($event)">
          </bus-room-card>
        } @empty {
          @if (shouldShowEmptyState()) {
            <rds-empty-state alignment="center" class="rooms-empty-state">
              <rds-empty-state-image namespace="blue" name="empty_box" />
              <rds-empty-state-title>No rooms to display</rds-empty-state-title>
              <rds-empty-state-subtitle>
                There are no rooms matching current filters. Try changing the
                date range or adjusting the filters.
              </rds-empty-state-subtitle>
            </rds-empty-state>
          }
        }

        @if (isLoadingMore() && !isCalendarActivated()) {
          @for (placeholder of skeletonPlaceholders(); track placeholder) {
            <div class="room-card-skeleton--pagination">
              <ng-container [ngTemplateOutlet]="skeletonCard"></ng-container>
            </div>
          }
        }
      }
    </div>
    <div #scrollSentinel class="scroll-sentinel"></div>
  </rds-tab>
  <rds-tab [active]="isCalendarActivated()">
    <ng-template rds-tab-label>
      <span>Managed Spaces View</span>
      <!--      <rds-badge [label]="number + ''" size="s" color="neutral"></rds-badge>-->
    </ng-template>
    <rds-alert type="info">
      This calendar shows only On Request rooms
    </rds-alert>
    @if (isCalendarActivated()) {
      <bus-calendar-overview class="mt-7 mb-7"></bus-calendar-overview>
    }
    <rds-alert type="info" class="rooms-3v-alert">
      Are you looking for a room not listed here? Check availability and book
      via
      <a
        rds-link
        standalone
        size="m"
        href="https://roche.book.3vrooms.app/"
        target="_blank"
        rel="noopener noreferrer"
        >3V-ROOMS <rds-icon size="s" namespace="outlined" icon="external_link"
      /></a>
    </rds-alert>
  </rds-tab>
</rds-tabs>
